/**
 * Returns true when custom interval is set to false, null or 0
 * @param customInterval
 * @return {boolean}
 */
export function isCustomIntervalFalsy(customInterval) {
    return customInterval !== undefined && !customInterval;
}
